// extracted by mini-css-extract-plugin
export default {"workoutContent":"WorkoutContent_workoutContent__UALJD"};